// @flow
import round from 'lodash/round';
import { DECIMAL_SEPARATORS } from './geometryConstants';

const UNIT_TO_METER_RATIOS = {
  M: 1,
  KM: 1000,
  NM: 1852,
  FT: 0.3048,
  FL: 30.48,
};

const DECIMAL_SEPARATOR_REGEXP = new RegExp(`[${DECIMAL_SEPARATORS}]`);

export function formatAltitude(value, valueIsInMeters = false, isAgl = false) {
  // GND is never `null`, it's just a plain `0`
  if (value === null) {
    return 'UNL';
  }

  const feet = valueIsInMeters ? value * 3.28084 : value;

  if (feet === 0) {
    return 'GND';
  } else if (feet === null) {
    return 'korlát nélkül';
  } else if (feet < 10000) {
    return `${round(feet)} ft ${isAgl ? 'AGL' : 'AMSL'}`;
  }

  return `FL${parseInt(feet / 100, 10)}`;
}

export function formatRadius(radius) {
  const rounded = round(radius, -2);

  if (radius > 1000) {
    return `${rounded / 1000}KM`;
  }

  return `${rounded}M`;
}

/**
 * Parses floats regardless of the decimal separator being used
 *
 * @param {string} value - a numeric string that may contain either a point or
 *                         comma as the decimal separator
 */
export function parseFloatLocaleAgnostic(value: string): number {
  return parseFloat(value.replace(DECIMAL_SEPARATOR_REGEXP, '.'));
}

export function parseDistanceToMeters(value, unit) {
  const uppercaseUnit = unit.toString().toUpperCase();

  if (uppercaseUnit in UNIT_TO_METER_RATIOS) {
    return (
      parseFloatLocaleAgnostic(value) * UNIT_TO_METER_RATIOS[uppercaseUnit]
    );
  }

  return NaN;
}



// WEBPACK FOOTER //
// ./utils/distance.js